import { defineMessages } from 'react-intl';

export default defineMessages({
  title: 'Powiadomienie o nowej wersji systemu',
  description: 'System Diagmatic został zaktualizowany. Informacje o szczegółach aktualizacji znajdziesz <Link>tutaj</Link>.',
  close: 'Zamknij',
});
